import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Box, InputBase } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { motion } from 'framer-motion';
import { images } from '../../assets';

// Styled components
const SearchContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#212121',
  borderRadius: '2px',
  padding: '2px 0px 2px 16px',
  gap: '6px',
  transition: 'all 0.3s ease',
  border: '1px solid transparent',
  '&:hover': {
    backgroundColor: '#333333',
    borderColor: '#444444',
  },
  '&:focus-within': {
    backgroundColor: '#333333',
    borderColor: '#666666',
  },
  maxWidth: '237px',
  height: '40px',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  flex: 1,
  color: '#ffffff',
  fontSize: '18px',
  fontWeight: 400,
  '& input': {
    padding: 0,
    '&::placeholder': {
      color: '#7a7a7a',
      opacity: 1,
    },
  },
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#7a7a7a',
  transition: 'color 0.3s ease',
}));

const ArrowButton = styled(motion.button)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  paddingLeft: '8px',
  paddingRight: '16px',
  borderRadius: '8px',
  color: '#ffffff',
  transition: 'all 0.3s ease',
}));

interface SearchInputProps {
  placeholder?: string;
  onSearch?: (value: string) => void;
  onChange?: (value: string) => void;
  defaultValue?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
                                                   placeholder = 'Search',
                                                   onSearch,
                                                   onChange,
                                                   defaultValue = '',
                                                 }) => {
  const [searchValue, setSearchValue] = useState(defaultValue);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchValue(value);
    if (onChange) {
      onChange(value);
    }
  };

  const handleSearch = () => {
    onSearch(searchValue);
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <SearchContainer>
      <IconWrapper>
        {/*<SearchIcon sx={{ fontSize: 20 }} />*/}
        <img src={images.searchIcon} height={20} width={20} alt="search" />
      </IconWrapper>

      <StyledInputBase
        placeholder={placeholder}
        value={searchValue}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        fullWidth
      />

      <div
        onClick={handleSearch}
        style={{ height: '100%', display: 'flex', alignItems: 'center', marginRight: '16px', cursor: 'pointer'}}
      >
        <img src={images.arrowRight} height={20} width={24} alt="arrow-right" />

      </div>
    </SearchContainer>
  );
};

export default SearchInput;